<template>
    <div v-if="!isLoadingPage" class="screen-number container-screen" :class="{ isPariMutuelLotto: this.propsDataSource.isPariMutuelLotto }">
        <TitleCommon :value="`${dataSource.title}${this.propsDataSource.isPariMutuelLotto ? '' : ` ${dataSource.gameNumber}`}`" />

         <div class="screen_number__bet-options" v-if="betOption && betOption.length > 0">
            <label
                v-for="(option, idx) in betOption"
                :key="idx"
                class="screen-number__radio"
            >
            <input
                class="screen-number__radio__input"
                type="radio"
                name="plan"
                :value="option"
                v-model="selectedBetOption"
            />
            <span class="screen-number__radio__control"></span>
            <span class="screen-number__radio__label">{{ getTranslatedText(option) }}</span>
            </label>
        </div>

        <!-- Banker Options -->
        <div class="screen_number__banker-options" v-if="bankerOptions && bankerOptions.length > 0">
            <label
                v-for="(banker, idx) in bankerOptions"
                :key="`banker-${idx}`"
                class="screen-number__banker-option"
            >
            <input
                class="screen-number__banker-option__input"
                type="checkbox"
                :value="banker"
                :checked="selectedBankerOption === banker"
                @change="onToggleBankerOption(banker)"
            />
            <span class="screen-number__banker-option__control"></span>
            <span class="screen-number__banker-option__label">{{ getTranslatedText(banker) }}</span>
            </label>
        </div>

        <div class="screen-number__box-btn-quick-pick" v-if="!shouldHideQuickSelection">
            <ButtonCommon :isNoHover="true" value="Quick Pick" className="screen-number__btn-quick-pick" nameFunction="on-quick-pick-number" v-if="rangePickNumber.length < 1" />
            <template v-else>
                <h3 class="screen-number__box-btn-quick-pick-flex-title">{{ getTranslatedText('Quick selection') }}</h3> 
                <div class="screen-number__box-btn-quick-pick-flex">
                    <template v-for="item in rangePickNumber">
                        <label class="screen-number__checkbox-quick-pick">
                            <input
                                class="screen-number__checkbox-quick-pick__input"
                                type="checkbox"
                                :value="item"
                                v-model="selectedQuickPickNumber"
                                @change="onChangeQuickPickNumber"
                            />
                            <span class="screen-number__checkbox-quick-pick__control"></span>
                            <span class="screen-number__checkbox-quick-pick__label">{{ item }}</span>
                        </label>
                    </template>
                </div>
                <div class="screen-number__box-btn-quick-pick-action">
                    <ButtonCommon 
                        :isNoHover="true" 
                        :value="getTranslatedText('Quick Pick')" 
                        className="screen-number__btn-quick-pick" 
                        nameFunction="on-quick-pick-number" 
                        :disabled="!selectedQuickPickNumber || (Array.isArray(selectedQuickPickNumber) && selectedQuickPickNumber.length === 0)"
                    />
                </div>
            </template>
        </div>
        <!-- Banker Mode Info -->
        <div class="screen-number__banker-info" v-if="isBankerMode()">
            <div class="screen-number__banker-group">
                <span class="screen-number__banker-label banker">{{ getTranslatedText('banker balls') }}: {{ bankerBalls.length }}/{{ getBankerMaxBalls() }}</span>
                <span class="screen-number__banker-label other" v-if="isBankerAgainstAll()">{{ getTranslatedText('other balls') }}: {{ otherBalls.length }}/{{ getOtherBallsMax() }}</span>
                <ButtonCommon 
                    :isNoHover="true" 
                    :value="getTranslatedText('clear')" 
                    className="screen-number__btn-clear-banker" 
                    nameFunction="on-clear-banker-selection"
                    v-if="bankerBalls.length > 0 || otherBalls.length > 0"
                />
            </div>
        </div>
        
        <div class="screen-number__list">
            <div class="screen-number__item" 
                :class="{ 
                    active: selection.includes(value.number),
                    'banker-ball': bankerBalls.includes(value.number),
                    'other-ball': otherBalls.includes(value.number)
                }" 
                v-for="(value, index) in listNumber" 
                :key="index" 
                @click="() => onSelectNumber(value.number)">
                {{ value.number }}
            </div>
        </div>
        <div class="screen-number__value-number">
            <input v-model="valueSelection" class="screen-number__input" type="text" @blur="onBlurValueSelection" />
        </div>
        <div class="screen-number__footer">
            <div class="screen-number__footer-action-price">
                <div class="screen-number__info">
                    <span class="screen-number__text bold">
                        {{ getTranslatedText(`${dataSource.title}`) }}
                        <template v-if="isCheckShowSelectPrice()">{{ dataSource.gameNumber }}</template>
                    </span>
                    <span class="screen-number__text">{{ renderPrice(this.propsDataSource.isPariMutuelLotto ? priceTicketCombinations : dataSource.wager) }}</span>
                </div>
                <span v-if="isCheckShowSelectPrice()" class="screen-number__text wager">
                    <b>{{ getTranslatedText('wager') }}</b> 
                    <template v-if="selectedBankerOption">
                        ({{ getTranslatedText('auto-calculated') }})
                    </template>
                    <template v-else-if="!isExtraGame() && selection.length > (dataSource.allowed_picks?.min || dataSource.numberQp)">
                        ({{ getTranslatedText('auto-calculated') }}: 50 {{ getTranslatedText('per combination') }})
                    </template>
                    <template v-else>
                        ({{ getTranslatedText('min') }} {{ renderPrice(50) }} - {{ getTranslatedText('max') }} {{ renderPrice(WARGER_MAX_ENV) }})
                    </template>
                </span>
                <input v-model="priceNumber" class="screen-number__input price" step="1" min="0" @blur="onBlurPriceNumber" v-on:keypress="onlyNumber" :disabled="!isCheckShowSelectPrice() || selectedBankerOption || (!isExtraGame() && selection.length > (dataSource.allowed_picks?.min || dataSource.numberQp))" />
                <div v-if="isCheckShowSelectPrice() && !selectedBankerOption && (isExtraGame() || selection.length <= (dataSource.allowed_picks?.min || dataSource.numberQp))" class="screen-number__box-button">
                    <ButtonCommon :value="`+${renderPrice('1000')}`" :paramFunction="1000" nameFunction="on-change-price-number" />
                    <ButtonCommon :value="`+${renderPrice('5000')}`" :paramFunction="5000" nameFunction="on-change-price-number" />
                    <ButtonCommon :value="`+${renderPrice('10000')}`" :paramFunction="10000" nameFunction="on-change-price-number" />
                </div>
            </div>
            <div class="screen-number__footer-action">
                <div class="screen-number__info">
                    <span class="screen-number__text bold">{{ getTranslatedText('total') }}</span>
                    <span class="screen-number__text bold">{{ renderPrice(totalNumber) }}</span>
                </div>
                <div class="screen-number__box-button">
                    <ButtonCommon :isNoHover="true" :isLoading="$store.state.isLoadingAddCart" value="clear" nameFunction="on-show-dialog-clear" />
                    <ButtonCommon :isNoHover="true" :isLoading="$store.state.isLoadingAddCart" type="error" value="add to cart" nameFunction="on-add-to-cart" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import languageMixins from '@/mixins/language/language-mixins';
import EventBus from '@/utils/EventBus';
import ButtonCommon from '@/components/common/button/index.vue';
import LoadingScreen from '@/components/common/loading/index.vue';
import TitleCommon from '@/components/common/title/index.vue';
import { formatPrice, generateCombinations, isObjEmpty, isStrEmpty } from '@/utils/utils';
import { CT_GAME_SLUG } from '@/constants/game';
import { CT_BANKER_TYPE, CT_BANKER_CONFIG } from '@/constants/app';

const WARGER_MIN_ENV = process.env.VUE_APP_WARGER_MIN || 2000;
const WARGER_MAX_ENV = process.env.VUE_APP_WARGER_MAX || 50000;

export default {
    mixins: [languageMixins],
    components: { ButtonCommon, LoadingScreen, TitleCommon },
    props: {
        propsDataSource: {
            type: Object,
            default: () => {},
        },
         limitEntry: {
            type: Number,
            default: -1,
        },
    },
    data() {
        return {
            isLoadingPage: true,
            dataSource: null,
            listNumber: [],
            selection: [],
            rangePickNumber: [],
            selectedQuickPickNumber: [],
            betOption: [],
            selectedBetOption: '',
            bankerOptions: [],
            selectedBankerOption: null,  // Changed to single value (radio button)
            bankerBalls: [],  // For banker_against_all: stores banker balls
            otherBalls: [],   // For banker_against_all: stores other balls
            valueSelection: '',
            priceNumber: 0,
            totalNumber: 0,
            defaultWager: 0,
            priceTicketCombinations: 0,
            WARGER_MIN_ENV,
            WARGER_MAX_ENV,
        };
    },
    created() {
        this.fetchdata();
        EventBus.$on('on-change-price-number', (param) => this.onChangePriceNumber(param));
        EventBus.$on('on-quick-pick-number', () => this.onClickQuickPick());
        EventBus.$on('on-clear-select-number', () => this.onClearSelectNumber());
        EventBus.$on('on-clear-banker-selection', () => this.onClearBankerSelection());
        EventBus.$on('on-show-dialog-clear', () => this.onShowConfirmClear());
        EventBus.$on('on-add-to-cart', () => this.onAddToCart());
        EventBus.$on('on-change-nav-games-3', (param) => {
            this.dataSource.numberQp = param.numberQp;
            this.dataSource.gameNumber = param.gameNumber;
            // Clear selected quickpick checkbox when switching games
            this.selectedQuickPickNumber = [];
            // Clear banker selection when switching games
            this.selectedBankerOption = null;
            // Update allowed_picks if provided
            if (param.allowed_picks) {
                this.dataSource.allowed_picks = param.allowed_picks;
                // Recalculate rangePickNumber based on new allowed_picks
                const allowed_picks = param.allowed_picks || {};
                if (!isObjEmpty(allowed_picks) && allowed_picks.min !== allowed_picks.max) {
                    this.rangePickNumber = Array.from({ length: allowed_picks.max - allowed_picks.min + 1 }, (_, index) => index + allowed_picks.min);
                } else {
                    this.rangePickNumber = [];
                }
            }
            // Update bankers if provided
            if (param.bankers && Array.isArray(param.bankers)) {
                this.bankerOptions = param.bankers;
            } else {
                this.bankerOptions = [];
            }
            this.onClearSelectNumber();
        });
    },
    computed: {
        shouldHideQuickSelection() {
            // Hide quick selection checkboxes when "Banker Against 1" is selected
            // because you're manually selecting exactly 1 ball
            return this.selectedBankerOption === CT_BANKER_TYPE.ONE_AGAINST_ALL;
        }
    },
    watch: {
        selection() {
            this.renderValueNumber();
        },
        priceNumber() {
            this.totalNumber = parseInt(this.priceNumber.replaceAll(',', '')) * this.propsDataSource.event_id.length;
            this.dataSource.wager = parseInt(this.priceNumber.replaceAll(',', ''));
        },
    },
    destroyed() {
        EventBus.$off('on-change-price-number');
        EventBus.$off('on-quick-pick-number');
        EventBus.$off('on-clear-select-number');
        EventBus.$off('on-clear-banker-selection');
        EventBus.$off('on-show-dialog-clear');
        EventBus.$off('on-add-to-cart');
        EventBus.$off('on-change-nav-games');
    },
    methods: {
        fetchdata() {
            this.dataSource = this.propsDataSource;
            this.priceNumber = this.renderPrice(parseInt(this.propsDataSource.wager));
            this.defaultWager = parseInt(this.propsDataSource.wager);
            this.priceTicketCombinations = parseInt(this.propsDataSource.wager);
            this.betOption = this.propsDataSource.bet_options
            this.selectedBetOption = this.propsDataSource.bet_options?.[0] || ''
            
            // Initialize banker options from propsDataSource
            if (this.propsDataSource.bankers && Array.isArray(this.propsDataSource.bankers)) {
                this.bankerOptions = this.propsDataSource.bankers
            } else {
                this.bankerOptions = []
            }
            
            this.listNumber = Array.from(Array(this.quantityNumberSelect()), (_, i) => {
                return { number: ++i, selected: false };
            });
            const allowed_picks = this.propsDataSource?.allowed_picks || {}
            // Only show quickpick checkboxes if min !== max (permutation betting supported)
            // If min === max (e.g., Chance3, Chance4, Chance5), no checkboxes - fixed picks only
            if (!isObjEmpty(allowed_picks) && allowed_picks.min !== allowed_picks.max) {
                this.rangePickNumber = Array.from({ length: allowed_picks.max - allowed_picks.min + 1 }, (_, index) => index + allowed_picks.min)
            } else {
                this.rangePickNumber = []
            }
            this.isLoadingPage = false;
        },

        renderTextTickets(arr) {
            // If in banker mode, format as [banker] [other]
            if (this.isBankerAgainstAll() && this.bankerBalls.length > 0) {
                const bankerText = this.bankerBalls.join(',');
                const otherText = this.otherBalls.length > 0 ? this.otherBalls.join(',') : '';
                return otherText ? `[${bankerText}] [${otherText}]` : `[${bankerText}]`;
            }
            
            // Handle both flat arrays and nested arrays
            let flatArr = arr;
            if (Array.isArray(arr) && arr.length > 0 && Array.isArray(arr[0])) {
                // If nested array (e.g., [[1,2,3]]), flatten it
                flatArr = arr[0];
            }
            
            let valueNumberSelectRender = '';
            flatArr.forEach((x, index) => {
                valueNumberSelectRender = `${valueNumberSelectRender}${index !== 0 ? ',' : ''} ${x}`;
            });
            return valueNumberSelectRender;
        },

        // action screen
        onClickQuickPick(number) {
            // Handle banker mode Quick Pick
            if (this.isBankerMode()) {
                const bankerType = this.selectedBankerOption;
                const allowed_picks = this.dataSource?.allowed_picks || {};
                const minPicks = allowed_picks.min || this.dataSource.numberQp || 2;
                
                if (bankerType === CT_BANKER_TYPE.ONE_AGAINST_ALL) {
                    // Pick 1 random ball
                    let numbers = Array(this.quantityNumberSelect())
                        .fill(0)
                        .map((_, index) => index + 1);
                    numbers.sort(() => Math.random() - 0.5);
                    this.selection = [numbers[0]];
                    return;
                }
                
                if (bankerType === CT_BANKER_TYPE.AGAINST_ALL) {
                    // ONLY for Extra games: use checkbox value for n-1 logic
                    let basePicks;
                    if (this.isExtraGame() && this.selectedQuickPickNumber && this.selectedQuickPickNumber.length > 0) {
                        basePicks = Array.isArray(this.selectedQuickPickNumber) 
                            ? this.selectedQuickPickNumber[0] 
                            : this.selectedQuickPickNumber;
                    } else {
                        basePicks = minPicks;
                    }
                    const bankerCount = basePicks - 1;
                    
                    // Determine how many other balls to select
                    let otherCount;
                    if (this.isExtraGame() && this.selectedQuickPickNumber && this.selectedQuickPickNumber.length > 0) {
                        // Extra games: other balls = checkbox value
                        otherCount = basePicks;
                    } else if (this.selectedQuickPickNumber && this.selectedQuickPickNumber.length > 0) {
                        // Other games with checkbox: use checkbox value for other balls
                        otherCount = Array.isArray(this.selectedQuickPickNumber) 
                            ? this.selectedQuickPickNumber[0] 
                            : this.selectedQuickPickNumber;
                    } else {
                        // No checkbox - random between minPicks and OTHER_MAX
                        const otherMin = minPicks;
                        const otherMax = CT_BANKER_CONFIG.AGAINST_ALL.OTHER_MAX;
                        otherCount = Math.floor(Math.random() * (otherMax - otherMin + 1)) + otherMin;
                    }
                    
                    // Check if banker balls are already manually selected
                    if (this.bankerBalls.length === bankerCount) {
                        // User has already selected banker balls manually
                        // Now Quick Pick only selects "other balls" with the specified count
                        
                        // Get all numbers except already selected banker balls
                        let availableNumbers = Array(this.quantityNumberSelect())
                            .fill(0)
                            .map((_, index) => index + 1)
                            .filter(num => !this.bankerBalls.includes(num));
                        
                        availableNumbers.sort(() => Math.random() - 0.5);
                        this.otherBalls = availableNumbers.slice(0, otherCount);
                        this.updateBankerSelection();
                        return;
                    } else {
                        // Banker balls NOT selected yet, pick both banker and other balls
                        
                        let allNumbers = Array(this.quantityNumberSelect())
                            .fill(0)
                            .map((_, index) => index + 1);
                        allNumbers.sort(() => Math.random() - 0.5);
                        
                        this.bankerBalls = allNumbers.slice(0, bankerCount);
                        this.otherBalls = allNumbers.slice(bankerCount, bankerCount + otherCount);
                        this.updateBankerSelection();
                        return;
                    }
                }
            }
            
            // Normal mode Quick Pick
            let numberQp = null;
            
            // Get the current game's allowed picks
            const allowed_picks = this.dataSource?.allowed_picks || {};
            const minPicks = allowed_picks.min || this.dataSource.numberQp;
            const maxPicks = allowed_picks.max || this.dataSource.numberQp;
            
            if (this.selectedQuickPickNumber && this.selectedQuickPickNumber.length > 0) {
                // Get the selected checkbox value (should be single value)
                const selectedCheckboxValue = Array.isArray(this.selectedQuickPickNumber) 
                    ? this.selectedQuickPickNumber[0] 
                    : this.selectedQuickPickNumber;
                
                // Validate that the selected checkbox value is within the current game's allowed range
                if (selectedCheckboxValue >= minPicks && selectedCheckboxValue <= maxPicks) {
                    numberQp = selectedCheckboxValue;
                } else {
                    // If checkbox value is invalid for current game, clear it and use default
                    this.selectedQuickPickNumber = [];
                    numberQp = minPicks;
                }
            } else if (number) {
                numberQp = number;
            } else {
                // Use min picks if allowed_picks exists, otherwise use numberQp
                numberQp = !isObjEmpty(allowed_picks) ? minPicks : this.dataSource.numberQp;
            }

            if (!numberQp) {
                return;
            }

            let numbers = Array(this.quantityNumberSelect())
                .fill(0)
                .map((_, index) => index + 1);
            numbers.sort(() => Math.random() - 0.5);
            numbers = [...numbers.slice(0, numberQp)];
            this.selection = [...numbers];
        },

        onChangeQuickPickNumber() {
            // Ensure only one checkbox is selected at a time
            if (this.selectedQuickPickNumber.length > 1) {
                // Keep only the last selected checkbox
                const lastSelected = this.selectedQuickPickNumber[this.selectedQuickPickNumber.length - 1];
                this.selectedQuickPickNumber = [lastSelected];
            }
            
            // Clear selections when checkbox changes
            this.selection = [];
            this.valueSelection = '';
            
            // Clear selection if checkbox is unchecked and limit was enforced
            if (this.selectedQuickPickNumber.length === 0) {
                // Optionally clear the number selection when no checkbox is selected
                // this.selection = [];
            } else {
                // Enforce the limit - remove excess selections if user had selected more
                const maxAllowed = this.selectedQuickPickNumber[0];
                if (this.selection.length > maxAllowed) {
                    this.selection = this.selection.slice(0, maxAllowed);
                }
            }
        },

        onToggleBankerOption(banker) {
            // Toggle: if clicking the same option, deselect it (back to normal mode)
            // If clicking a different option, switch to that option
            if (this.selectedBankerOption === banker) {
                this.selectedBankerOption = null;
            } else {
                this.selectedBankerOption = banker;
            }
            // Clear selections when banker option changes
            this.selection = []
            this.bankerBalls = []
            this.otherBalls = []
            this.valueSelection = ''
            this.selectedQuickPickNumber = [] // Clear quick pick selection when banker option changes
            
            // Update info display
            this.$forceUpdate();
        },

        onShowConfirmClear() {
            const param = {
                description: 'Are you sure you want to delete?',
                nameFunction: 'on-clear-select-number',
            };
            EventBus.$emit('on-show-dialog', param);
        },

        onClearSelectNumber() {
            this.priceNumber = this.renderPrice(parseInt(this.defaultWager));
            this.selection = [];
            this.valueSelection = '';
            this.bankerBalls = [];
            this.otherBalls = [];
        },
        
        onClearBankerSelection() {
            // Clear banker mode selections
            this.bankerBalls = [];
            this.otherBalls = [];
            this.selection = [];
            this.valueSelection = '';
            this.priceNumber = this.renderPrice(parseInt(this.defaultWager));
        },

        onAddToCart() {
            const {transact, transact645, transact545, transact459} = this.$store.state
            this.$store.state.isLoadingAddCart = true;

            let numberQp = this.dataSource.numberQp;
            let text = this.getTranslatedText(`Please make sure that you select [number] of balls!`, {
                number: numberQp,
            });
            
            // Banker mode validation
            if (this.selectedBankerOption) {
                if (this.selectedBankerOption === CT_BANKER_TYPE.ONE_AGAINST_ALL) {
                    // Banker one against all: must select exactly 1 ball
                    if (this.selection.length !== CT_BANKER_CONFIG.ONE_AGAINST_ALL.MAX_BALLS) {
                        text = this.getTranslatedText(`Please select exactly 1 ball for Banker One Against All`);
                        const param = {
                            text,
                            type: 'warning',
                        };
                        EventBus.$emit('show-notications', param);
                        this.$store.state.isLoadingAddCart = false;
                        return false;
                    }
                    // Valid - continue to add to cart
                    numberQp = 1;
                } else if (this.selectedBankerOption === CT_BANKER_TYPE.AGAINST_ALL) {
                    // Banker against all: validate two groups
                    // ONLY for Extra games: use checkbox value for n-1 logic
                    let basePicks;
                    if (this.isExtraGame() && this.selectedQuickPickNumber && this.selectedQuickPickNumber.length > 0) {
                        basePicks = Array.isArray(this.selectedQuickPickNumber) 
                            ? this.selectedQuickPickNumber[0] 
                            : this.selectedQuickPickNumber;
                    } else {
                        const allowed_picks = this.dataSource?.allowed_picks || {};
                        basePicks = allowed_picks.min || this.dataSource.numberQp || 2;
                    }
                    const bankerMaxBalls = basePicks - 1;
                    
                    // For "other balls" validation: always use minimum of 2 (or game's allowed_picks.min)
                    // The checkbox value should NOT affect "other balls" minimum - it's only for banker balls count
                    const allowed_picks = this.dataSource?.allowed_picks || {};
                    const otherBallsMin = allowed_picks.min || 2;
                    
                    if (this.bankerBalls.length !== bankerMaxBalls) {
                        text = this.getTranslatedText(`Please select exactly [count] banker ball(s)`, {
                            count: bankerMaxBalls
                        });
                        const param = {
                            text,
                            type: 'warning',
                        };
                        EventBus.$emit('show-notications', param);
                        this.$store.state.isLoadingAddCart = false;
                        return false;
                    }
                    
                    if (this.otherBalls.length < otherBallsMin || this.otherBalls.length > CT_BANKER_CONFIG.AGAINST_ALL.OTHER_MAX) {
                        text = this.getTranslatedText(`Please select between [min] and [max] other balls`, {
                            min: otherBallsMin,
                            max: CT_BANKER_CONFIG.AGAINST_ALL.OTHER_MAX
                        });
                        const param = {
                            text,
                            type: 'warning',
                        };
                        EventBus.$emit('show-notications', param);
                        this.$store.state.isLoadingAddCart = false;
                        return false;
                    }
                    // Valid - continue to add to cart
                }
            }
            
            // Check if a quickpick checkbox is selected - if so, require exact match
            // NOTE: For banker_against_all mode, checkbox validation is skipped for "other balls"
            // because "other balls" should be validated against range (2-20), not checkbox value
            if (this.selectedQuickPickNumber && this.selectedQuickPickNumber.length > 0 && this.selectedBankerOption !== CT_BANKER_TYPE.AGAINST_ALL) {
                const selectedCheckboxValue = Array.isArray(this.selectedQuickPickNumber) 
                    ? this.selectedQuickPickNumber[0] 
                    : this.selectedQuickPickNumber;
                
                // Validate checkbox value is within game's allowed range
                const allowed_picks = this.dataSource?.allowed_picks || {};
                const minPicks = allowed_picks.min || this.dataSource.numberQp;
                const maxPicks = allowed_picks.max || this.dataSource.numberQp;
                
                if (selectedCheckboxValue >= minPicks && selectedCheckboxValue <= maxPicks) {
                    // Require exact match when checkbox is selected (only for normal mode)
                    const actualCount = this.selection.length;
                    
                    if (actualCount !== selectedCheckboxValue) {
                        const missing = selectedCheckboxValue - actualCount;
                        text = this.getTranslatedText(`[expected] BALLS expected, [missing] missing`, {
                            expected: selectedCheckboxValue,
                            missing: missing,
                        });
                        const param = {
                            text,
                            type: 'warning',
                        };
                        EventBus.$emit('show-notications', param);
                        this.$store.state.isLoadingAddCart = false;
                        return false;
                    }
                    numberQp = selectedCheckboxValue;
                } else {
                    // Invalid checkbox value, clear it and use default validation
                    this.selectedQuickPickNumber = [];
                }
            }
            
            // Default validation if no checkbox selected and not in banker mode
            if (!this.selectedBankerOption && !isObjEmpty(this.dataSource.allowed_picks) && (!this.selectedQuickPickNumber || this.selectedQuickPickNumber.length === 0)) {
                numberQp = this.dataSource.allowed_picks.min;
                text = this.getTranslatedText(`Please make sure that you select from [min] to [max] of balls!`, {
                    min: this.dataSource.allowed_picks?.min || 2, 
                    max: this.dataSource.allowed_picks?.max || 5,
                });
            }

            const param = this.dataSource;

            let cartSelected
            let isCheckLimit = false

            if (param.game === 'lotto-5-45') {
                cartSelected = transact545
            } else if (param.game === 'lotto-6-45') {
                cartSelected = transact645
            } else if (CT_GAME_SLUG.LOTTO_459.includes(param.game?.toLowerCase())) {
                cartSelected = transact459                
            } else {
                cartSelected = transact                
            }

            if(this.limitEntry > 0 && cartSelected.length >= this.limitEntry) {
                text = this.getTranslatedText(`You can add only [entry] entry into the betslip`, {
                    entry: this.limitEntry
                }) 
                isCheckLimit = true
            }
            
            // Skip normal numberQp check if in banker mode (already validated above)
            if (!this.selectedBankerOption && (numberQp > this.selection.length || isCheckLimit)) {
                const param = {
                    text,
                    type: 'warning',
                };
                EventBus.$emit('show-notications', param);
                this.$store.state.isLoadingAddCart = false;

                return false;
            }
            
            // Check limit for banker mode too
            if (isCheckLimit) {
                const param = {
                    text,
                    type: 'warning',
                };
                EventBus.$emit('show-notications', param);
                this.$store.state.isLoadingAddCart = false;

                return false;
            }

            // Format selection based on banker mode
            let formattedSelection;
            if (this.isBankerAgainstAll() && this.bankerBalls.length > 0 && this.otherBalls.length > 0) {
                // For banker_against_all: send as [[banker_balls], [other_balls]]
                formattedSelection = [this.bankerBalls, this.otherBalls];
            } else {
                // For normal mode and banker_one_against_all: wrap in array
                // Backend expects: [[num1, num2, num3]]
                formattedSelection = [this.selection];
            }
            
            param['selection'] = formattedSelection;
            param['date'] = formattedSelection;
            param['wager'] = parseInt(this.priceNumber.replaceAll(',', ''));
            param['limitEntry'] = this.limitEntry
            param['market_option'] = this.selectedBetOption
            param['banker_option'] = this.selectedBankerOption || null
            param['id'] = new Date().getTime().toString(36).concat(performance.now().toString(), Math.random().toString()).replace(/\./g, '');
            
            this.$store.dispatch('onAddToCart', param);
            this.onClearSelectNumber();
        },

        // select number
        renderValueNumber() {
            const selection = [...this.selection];
            const numberSelect = selection.sort((a, b) => a - b);

            // Get min and max picks for the current game
            const allowed_picks = this.dataSource?.allowed_picks || {};
            let minPicks = this.dataSource.numberQp;
            let maxPicks = this.dataSource.numberQp;
            
            if (!isObjEmpty(allowed_picks)) {
                minPicks = allowed_picks.min || minPicks;
                maxPicks = allowed_picks.max || maxPicks;
            }

            minPicks = parseInt(minPicks);
            maxPicks = parseInt(maxPicks);

            // Check for banker mode first (takes priority over normal pricing)
            if (this.selectedBankerOption) {
                if (this.selectedBankerOption === CT_BANKER_TYPE.ONE_AGAINST_ALL) {
                    // Banker one against all: 1 ball against 89 others = 89 * 50 = 4,450
                    const againstBalls = CT_BANKER_CONFIG.ONE_AGAINST_ALL.AGAINST_BALLS;
                    const pricePerCombination = CT_BANKER_CONFIG.ONE_AGAINST_ALL.PRICE_PER_COMBINATION;
                    let priceTicketCombinations = againstBalls * pricePerCombination;
                    this.priceTicketCombinations = priceTicketCombinations;
                    this.totalNumber = priceTicketCombinations * this.propsDataSource.event_id.length;
                    this.priceNumber = this.renderPrice(priceTicketCombinations);
                } else if (this.selectedBankerOption === CT_BANKER_TYPE.AGAINST_ALL) {
                    // Banker against all: number of other balls * 50
                    const otherBallsCount = this.otherBalls.length;
                    const pricePerCombination = CT_BANKER_CONFIG.AGAINST_ALL.PRICE_PER_COMBINATION;
                    let priceTicketCombinations = otherBallsCount * pricePerCombination;
                    this.priceTicketCombinations = priceTicketCombinations;
                    this.totalNumber = priceTicketCombinations * this.propsDataSource.event_id.length;
                    this.priceNumber = this.renderPrice(priceTicketCombinations);
                }
            } else {
                // Normal pricing (no banker mode)
                
                // Check if this is Extra 6 or Extra 7 (these are NOT combination games)
                const title = this.dataSource?.title?.toLowerCase() || '';
                const game = this.dataSource?.game?.toLowerCase() || '';
                const isExtraGame = title.includes('extra') || game.includes('extra');

                // Check if this is a permutation bet (selection > min) AND NOT Extra 6/7
                if (!isExtraGame && selection.length > minPicks) {
                    // Combination bet: calculate combinations and use 50 per combination
                    let combinations = generateCombinations(selection.length, minPicks);
                    let pricePerCombination = 50; // Fixed price per combination
                    let priceTicketCombinations = pricePerCombination * combinations;
                    this.priceTicketCombinations = priceTicketCombinations;
                    this.totalNumber = priceTicketCombinations * this.propsDataSource.event_id.length;
                    // Update the wager input to show the calculated price
                    this.priceNumber = this.renderPrice(priceTicketCombinations);
                } else {
                    // Single bet: use user-entered wager (min 50)
                    // This includes: Extra 6/7 (always single), or regular games with selection = min
                    let priceTicketCombinations = parseInt(this.priceNumber.replaceAll(',', ''));
                    // Ensure minimum wager of 50 for single bets
                    if (priceTicketCombinations < 50) {
                        priceTicketCombinations = 50;
                        this.priceNumber = this.renderPrice(priceTicketCombinations);
                    }
                    this.priceTicketCombinations = priceTicketCombinations;
                    this.totalNumber = priceTicketCombinations * this.propsDataSource.event_id.length;
                }
            }

            let valueNumberSelectClone = this.renderTextTickets(numberSelect);

            this.valueSelection = valueNumberSelectClone;
        },

        onSelectNumber(number) {
            // Check if banker mode is active
            const bankerType = this.selectedBankerOption;
            
            if (bankerType === CT_BANKER_TYPE.ONE_AGAINST_ALL) {
                // Banker one against all: only 1 ball allowed
                const index = this.selection.findIndex((x) => x === number);
                if (index !== -1) {
                    this.selection.splice(index, 1);
                } else {
                    // Only allow 1 ball
                    this.selection = [number];
                }
                return;
            }
            
            if (bankerType === CT_BANKER_TYPE.AGAINST_ALL) {
                // Banker against all: manage two groups
                this.handleBankerAgainstAllSelection(number);
                return;
            }
            
            // Normal selection (no banker mode)
            const selection = this.selection;
            const index = selection.findIndex((x) => x === number);
            if (index !== -1) {
                selection.splice(index, 1);
            } else {
                // If a quickpick checkbox is selected, limit manual selection to that number
                // Otherwise, use the full max from allowed_picks
                let maxAllowed = this.maxLengthQuickPick();
                
                if (this.selectedQuickPickNumber && this.selectedQuickPickNumber.length > 0) {
                    // Use the selected checkbox value to limit manual selection
                    const selectedCheckboxValue = Array.isArray(this.selectedQuickPickNumber) 
                        ? this.selectedQuickPickNumber[0] 
                        : this.selectedQuickPickNumber;
                    maxAllowed = selectedCheckboxValue;
                }
                
                if (maxAllowed > this.selection.length) {
                    selection.push(number);
                }
            }

            this.selection = [...selection];
        },
        
        handleBankerAgainstAllSelection(number) {
            // For banker_against_all: two groups
            // Group 1 (banker balls): depends on game type
            // Group 2 (other balls): 1 to 20
            
            // ONLY for Extra games: use checkbox value for n-1 logic
            let basePicks;
            if (this.isExtraGame() && this.selectedQuickPickNumber && this.selectedQuickPickNumber.length > 0) {
                // Extra 6/7: checkbox determines the picks
                basePicks = Array.isArray(this.selectedQuickPickNumber) 
                    ? this.selectedQuickPickNumber[0] 
                    : this.selectedQuickPickNumber;
            } else {
                // Other games: use game's minimum picks
                const allowed_picks = this.dataSource?.allowed_picks || {};
                basePicks = allowed_picks.min || this.dataSource.numberQp || 2;
            }
            const bankerMaxBalls = basePicks - 1;
            
            // Check if number is already in banker balls
            const bankerIndex = this.bankerBalls.findIndex((x) => x === number);
            if (bankerIndex !== -1) {
                this.bankerBalls.splice(bankerIndex, 1);
                this.updateBankerSelection();
                return;
            }
            
            // Check if number is already in other balls
            const otherIndex = this.otherBalls.findIndex((x) => x === number);
            if (otherIndex !== -1) {
                this.otherBalls.splice(otherIndex, 1);
                this.updateBankerSelection();
                return;
            }
            
            // Add to appropriate group
            // Priority: fill banker balls first, then other balls
            if (this.bankerBalls.length < bankerMaxBalls) {
                this.bankerBalls.push(number);
            } else if (this.otherBalls.length < CT_BANKER_CONFIG.AGAINST_ALL.OTHER_MAX) {
                this.otherBalls.push(number);
            }
            
            this.updateBankerSelection();
        },
        
        updateBankerSelection() {
            // Combine both arrays for display purposes
            this.selection = [...this.bankerBalls, ...this.otherBalls];
        },

        onBlurValueSelection() {
            let inputArray = this.valueSelection
                .split(',')
                .map((num) => Number(num.trim()))
                .filter((num, index, self) => num >= 1 && num <= this.quantityNumberSelect() && index === self.indexOf(num));

            // If a quickpick checkbox is selected, limit to that number
            // Otherwise, use the full max from allowed_picks
            let maxAllowed = this.maxLengthQuickPick();
            
            if (this.selectedQuickPickNumber && this.selectedQuickPickNumber.length > 0) {
                // Use the selected checkbox value to limit manual selection
                const selectedCheckboxValue = Array.isArray(this.selectedQuickPickNumber) 
                    ? this.selectedQuickPickNumber[0] 
                    : this.selectedQuickPickNumber;
                maxAllowed = selectedCheckboxValue;
            }

            inputArray = inputArray.slice(0, maxAllowed);
            this.valueSelection = inputArray.join(',');
            this.selection = [...inputArray];
        },

        // change price
        onBlurPriceNumber() {
            // Get min and max picks for the current game
            const allowed_picks = this.dataSource?.allowed_picks || {};
            let minPicks = this.dataSource.numberQp;
            
            if (!isObjEmpty(allowed_picks)) {
                minPicks = allowed_picks.min || minPicks;
            }
            minPicks = parseInt(minPicks);

            // Check if in banker mode - price is auto-calculated
            if (this.selectedBankerOption) {
                // Banker bets have fixed auto-calculated prices
                // Don't allow user to change it manually
                return;
            }
            
            // Check if this is a combination bet (but NOT Extra 6/7)
            const isCombinationBet = !this.isExtraGame() && this.selection.length > minPicks;
            
            if (isCombinationBet) {
                // For combination bets, wager is auto-calculated (50 per combination)
                // Don't allow user to change it manually
                return;
            }

            // For single bets (including Extra 6/7), enforce min 50 and max limits
            let price = !isStrEmpty(this.priceNumber) ? this.priceNumber.replaceAll(',', '') : 0;
            let value = parseFloat(price) || 0;
            let minWager = 50; // Minimum wager for single bets
            if (value < minWager) value = minWager;
            if (value > this.WARGER_MAX_ENV) value = this.WARGER_MAX_ENV;
            this.priceNumber = this.renderPrice(value);
        },

        onChangePriceNumber(value) {
            let price = value || 0;
            let priceMore = parseInt(this.priceNumber.replaceAll(',', '')) + price;
            if (priceMore > WARGER_MAX_ENV) priceMore = WARGER_MAX_ENV;
            this.priceNumber = this.renderPrice(priceMore);
        },

        onlyNumber(event) {
            if (event.key === '-' && event.target.selectionStart !== 0) {
                event.preventDefault();
                return;
            }
            if (event.keyCode < 48 || event.keyCode > 57) {
                event.preventDefault();
            }
        },

        // uti render
        renderPrice(price) {
            return formatPrice(price);
        },

        // on change length game
        quantityNumberSelect() {
            let number = 45;

            if (this.propsDataSource.game === 'lotto-5-45') {
                number = 45;
            } else if (this.propsDataSource.game === 'lotto-6-45') {
                number = 45;
            } else if (CT_GAME_SLUG.LOTTO_459.includes(this.propsDataSource.game?.toLowerCase())) {
                number = 59;
            } else {
                number = 90;
            }
            return number;
        },

        maxLengthQuickPick() {
            let numberQp = this.dataSource.numberQp;

            if (!isObjEmpty(this.dataSource.allowed_picks)) {
                numberQp = this.dataSource.allowed_picks.max;
            }

            let maxLength = this.propsDataSource.isPariMutuelLotto ? this.propsDataSource.maxPicks : numberQp;
            return maxLength;
        },


        isCheckShowSelectPrice() {
            if(this.propsDataSource.isPariMutuelLotto) {
                return false
            }
            return true
        },

        isExtraGame() {
            // Check if this is Extra 6 or Extra 7 (these are NOT combination games)
            const title = this.dataSource?.title?.toLowerCase() || '';
            const game = this.dataSource?.game?.toLowerCase() || '';
            return title.includes('extra') || game.includes('extra');
        },
        
        isBankerMode() {
            return this.selectedBankerOption !== null && this.selectedBankerOption !== '';
        },
        
        isBankerAgainstAll() {
            return this.selectedBankerOption === CT_BANKER_TYPE.AGAINST_ALL;
        },
        
        getBankerMaxBalls() {
            if (!this.isBankerMode()) return 0;
            
            const bankerType = this.selectedBankerOption;
            if (bankerType === CT_BANKER_TYPE.ONE_AGAINST_ALL) {
                return CT_BANKER_CONFIG.ONE_AGAINST_ALL.MAX_BALLS;
            }
            
            if (bankerType === CT_BANKER_TYPE.AGAINST_ALL) {
                // ONLY for Extra games: use checkbox value for n-1 logic
                // For other games (Turbo, etc): use game's allowed_picks.min
                let basePicks;
                if (this.isExtraGame() && this.selectedQuickPickNumber && this.selectedQuickPickNumber.length > 0) {
                    // Extra 6/7: checkbox determines the picks (e.g., checkbox 5 = 4 bankers)
                    basePicks = Array.isArray(this.selectedQuickPickNumber) 
                        ? this.selectedQuickPickNumber[0] 
                        : this.selectedQuickPickNumber;
                } else {
                    // Other games: use game's minimum picks
                    const allowed_picks = this.dataSource?.allowed_picks || {};
                    basePicks = allowed_picks.min || this.dataSource.numberQp || 2;
                }
                return basePicks - 1;
            }
            
            return 0;
        },
        
        getOtherBallsMax() {
            return CT_BANKER_CONFIG.AGAINST_ALL.OTHER_MAX;
        }
    },
};
</script>

<style lang="scss">
@import '~ThemePath/scss/games/_number.scss';
</style>
